import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterChip } from '../components/FilterChip';
import { MetricRow } from '../components/MetricRow';
import { PageHeader } from '../components/PageHeader';
import { Button } from '../components/ui/Button';
import { Card, SectionTitle } from '../components/ui/Card';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
export function BodyMetrics() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const metrics = useMetrics();
  const visible = metrics.bodyMetrics.filter(metric => !metrics.isHidden(metric.id));
  const hidden = metrics.bodyMetrics.filter(metric => metrics.isHidden(metric.id));
  return <div className="px-2 pb-2" data-id="element-2157" data-mp="2v95l183brdzf">
      <PageHeader title={t('metrics.body.title')} subtitle={t('metrics.body.subtitle')} showBack data-id="element-2158" data-mp="2hbqsvvloss3r" />

      <Card className="p-2" data-id="element-2159" data-mp="2lc0xb3ttzagi">
        <SectionTitle data-id="element-2160" data-mp="2lcalclvbf7jk">{t('metrics.units')}</SectionTitle>
        <ul className="flex gap-1" data-id="element-2161" data-mp="2z1f1by3pbs0o">
          {(['metric', 'imperial'] as const).map(system => <li key={system} data-id="element-2162" data-mp="2u3wq2127p0pi">
              <FilterChip label={t(`metrics.units.${system}`)} active={metrics.unitSystem === system} onClick={() => metrics.setUnitSystem(system)} data-id="element-2163" data-mp="2u2lrcfnmij59" />
            </li>)}
        </ul>
      </Card>

      <Card className="mt-2 px-2" data-id="element-2164" data-mp="2gaxeub9gpsnr">
        <ul data-id="element-2165" data-mp="2gc03ecjbbj0i">
          {visible.map(metric => <MetricRow key={metric.id} label={t(`metrics.${metric.id}`)} kind={metric.kind} value={metric.value} derived={!metric.editable} hint={metric.id === 'bmi' ? t('metrics.bmiHint') : undefined} onOpen={metric.id === 'weight' ? () => navigate('/perfil/grafico/weight') : metric.id === 'ffm' || metric.id === 'bodyFat' || metric.id === 'water' ? () => navigate('/perfil/grafico/body') : undefined} data-id="element-2166" data-mp="2bd5jt8ditqfc" />)}
        </ul>
      </Card>

      {hidden.length > 0 && <section className="mt-3" data-id="element-2167" data-mp="2r34zdtteyaqw">
          <SectionTitle action={<button type="button" onClick={metrics.restoreHidden} className="text-[11px] font-medium text-gold-deep transition-colors duration-150 ease-brand hover:text-deep" data-id="element-2169" data-mp="2w0d8l4wl34g0">
                {t('metrics.restore')}
              </button>} data-id="element-2168" data-mp="2w1oo21ze60my">
            {t('metrics.hidden')}
          </SectionTitle>
          <ul className="rounded-card border border-dashed border-sand-line bg-white/50 px-2" data-id="element-2170" data-mp="2dbgnnrn2toag">
            {hidden.map(metric => <li key={metric.id} className="flex min-h-[48px] items-center border-b border-sand-line text-[13px] text-muted last:border-b-0" data-id="element-2171" data-mp="3jr0vawb5rymm">
                {t(`metrics.${metric.id}`)}
              </li>)}
          </ul>
        </section>}

      <Button variant="primary" size="lg" fullWidth className="mt-3" onClick={() => navigate('/perfil/corpo/editar')} data-id="element-2172" data-mp="1860cew9nibcq">
        {metrics.currentWeightKg == null ? t('hydration.addWeight') : t('metrics.editBody')}
      </Button>
    </div>;
}